// extracted by mini-css-extract-plugin
export default {"surveyContainer":"DynamicSurvey_surveyContainer__Br168"};